<div class="auto-ml-page">
    <app-top-stepper></app-top-stepper>
    <div class="auto-ml-page__middle-sec">
        <div class="auto-ml-page__title">
            Select the variable you want to analyze
        </div>
        <div class="auto-ml-page__dropdown-outer">
            <div class="auto-ml-page__dropdown">
                <ng-select
                (change)="_autoMl.isValidDepVariable =true"
                [disabled]="_autoMl.iterationSet[0].target_columns.length >0"
                [items]="_autoMl.tableColumns.target_variables"
                placeholder="Select Variable"
                [(ngModel)]="_autoMl.dependentVariable">
                </ng-select>
              <div *ngIf="!_autoMl.isValidDepVariable" class="auto-ml-page__alerts-contents">
                  <img src="assets/images/svg/alert-info-icon.svg" alt="">
                  Please Select Dependent Variable
              </div>
              </div>
              <div class="auto-ml-page__btn" (click)="_autoMl.runIterationSet(0);" [ngClass]="{'po-none': _autoMl.iterationSet[0].isRunLoad}">
                Run Model
                <svg *ngIf="!_autoMl.iterationSet[0].isRunLoad" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M10.5 19.6004C15.7651 19.6004 20.0333 15.5262 20.0333 10.5004C20.0333 5.4746 15.7651 1.40039 10.5 1.40039C5.23489 1.40039 0.966675 5.4746 0.966675 10.5004C0.966675 15.5262 5.23489 19.6004 10.5 19.6004Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14.6656 10.6271L8.37527 14.2589L8.37527 6.99542L14.6656 10.6271Z" fill="white"/>
                </svg>
                <app-circle-loader *ngIf="_autoMl.iterationSet[0].isRunLoad" color="white"></app-circle-loader>
            </div>
        </div>
        
        <div class="auto-ml-page__tags-outer">
            <div *ngFor="let item of _autoMl.iterationSet[0].all_columns" class="auto-ml-page__tag">
                {{item.name}}
            </div>
        </div>
        
    </div>
    <div class="auto-ml-page__bottom-sec">
        <object data="assets/images/svg/chart-moving-animation.svg" type="">

        </object>
        <object data="assets/images/svg/analyze-animated.svg" type="" class="auto-ml-page__magnifying-glass"></object>
    </div>
    <div *ngIf="_autoMl.iterationSet[0].isRunLoad" class="auto-ml-page__loading-box">
        <div class="auto-ml-page__loading-card">
            <div class="auto-ml-page__loading-percent">
              <svg>
                <circle cx="50%" cy="50%" r="23"></circle>
                <circle cx="50%" cy="50%" r="23" [style]="'--percent:'+ _autoMl.value"></circle>
              </svg>
              <div class="auto-ml-page__loading-icon">
                <img src="assets/images/svg/time-icon.svg" alt="">
              </div>
            </div>
        </div>
        <div class="auto-ml-page__loading-contents">
            
            <div class="auto-ml-page__loading-per" >
                {{_autoMl.value+'%'}}
            </div>
            <div class="auto-ml-page__loading-txt">
                <div [ngSwitch]="_autoMl.value">
                    {{_autoMl.loaderText}}
                </div>
            </div>
        </div>
    </div>
</div>